export const ProfessionalGuardEnum = {
    FREE: 'FREE',
    BUSY: 'BUSY',
    AVAILABLE: 'AVAILABLE',
};
